import { render, staticRenderFns } from "./BasePaymentInput.vue?vue&type=template&id=5e8ab164&scoped=true"
import script from "./BasePaymentInput.vue?vue&type=script&lang=js"
export * from "./BasePaymentInput.vue?vue&type=script&lang=js"
import style0 from "./BasePaymentInput.vue?vue&type=style&index=0&id=5e8ab164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8ab164",
  null
  
)

export default component.exports